/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { createSlice } from '@reduxjs/toolkit';

interface Cache {
  hasCache: boolean;
  loadedCache: boolean;
}
const initialState: Cache = {
  hasCache: false,
  loadedCache: false
};

const slice = createSlice({
  name: 'locationCache',
  initialState,
  reducers: {
    setLoaded: (state) => {
      state.loadedCache = true;
    }
  }
});

export default slice.reducer;

function isQuotaExceeded(error: unknown): boolean {
  if (!(error instanceof DOMException)) return false;
  return (
    error.name === 'QuotaExceededError' ||
    error.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
    error.code === 22 ||
    error.code === 1014
  );
}

function safeSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    if (!isQuotaExceeded(error)) throw error;
    try {
      localStorage.removeItem(key);
    } catch {}
  }
}

export function readLocationCache<T>(
  locationSlug: string,
  key: string
): T | null {
  const data = localStorage.getItem(`${locationSlug}_${key}`);
  if (data == null) return null;
  const parsedData = JSON.parse(data) as Record<string, T>;
  if (!parsedData?.[key]) return null;
  return parsedData[key];
}

export function writeLocationCache<T>(
  locationSlug: string,
  key: string,
  data: T
): void {
  const storage = JSON.parse(
    localStorage.getItem(`${locationSlug}_${key}`) ?? '{}'
  ) as Record<string, T>;
  storage[key] = data;

  safeSetItem(`${locationSlug}_${key}`, JSON.stringify(storage));
}

export function writeUrlCache<T>(url: string, data: T): void {
  safeSetItem(url, JSON.stringify(data));
}

export function ReadUrlCache<T>(url: string): T | null {
  const data = localStorage.getItem(url);
  if (data == null) return null;
  return JSON.parse(data);
}

export function updateLocationCache<T>(
  locationSlug: string,
  key: string,
  data: T
): void {
  const cached: any = readLocationCache(locationSlug, key);
  if (cached)
    safeSetItem(
      `${locationSlug}_${key}`,
      JSON.stringify({ [key]: { ...cached, ...data } })
    );
}
